import React from 'react';
import BillingField from './BillingField';
import { IBillingValues, SelectItem } from '../types/locationTypes';
import CommonRow from './CommonRow';
import { useStylesForForms } from './billingHelpers';

 interface BillingFormType1Props {
     billingValuesObj: IBillingValues,
     handleSetBillingValuesObj: any,
     disabled: boolean,
     retainerIntervals: SelectItem[],
 }


const BillingFormType1: React.FC<BillingFormType1Props> = ({
    billingValuesObj,
    handleSetBillingValuesObj,
    disabled,
    retainerIntervals,
}) => {
    const classes = useStylesForForms();
    return (
        <>
            <div className={classes.flexContainer}>
                <div>
                    <hr className={classes.separator} />
                </div>
                <div className={classes.row}>
                    <BillingField
                        title="TRANSFER FEE ($)"
                        description="Fee per transfer"
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.transferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('transferFees', newValue)}
                    />
                </div>
                <div>
                    <hr className={classes.separator} />
                </div>
                <CommonRow
                    billingValuesObj={billingValuesObj}
                    handleSetBillingValuesObj={handleSetBillingValuesObj}
                    disabled={disabled}
                    parentClasses={classes}
                    retainerIntervals={retainerIntervals}                
                />
            </div>

        </>
    );
}

export default BillingFormType1;